import { FC } from 'react';

import loginBackground from '@/assets/loginBackground.png';

const LoginBackgroundImage: FC = () => {
  return (
    <img
      src={loginBackground}
      alt="LoginBackground"
      loading="lazy"
      className="w-full h-full object-cover object-right"
    />
  );
};

export default LoginBackgroundImage;
